
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 11"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M15.0303 2.03029L6.53029 10.5303c-.1465.1465-.33791.2197-.53028.2197-.19238 0-.38378-.0732-.53028-.2197L.969727 6.03029c-.292969-.29297-.292969-.76759 0-1.06056.292973-.29297.767593-.29297 1.060563 0l3.96972 3.96972L13.9697.969727c.293-.292969.7676-.292969 1.0606 0 .293.292973.293.767593 0 1.060563z"}})])
          )
        }
      }
    